import * as yup from 'yup';

yup.addMethod(yup.string, 'noUrlInContent', function () {
  return this.test({
    name: 'no-url-in-content',
    exclusive: true,
    message: 'components.form.validation.string.no-url-in-content',
    test: (value) => {
      if (!value) {
        return true;
      }

      // Matches an explicit link (scheme or www.) or a bare domain. Bare domains are
      // limited to a known list of endings so ordinary prose - "o.a.", "v.v.",
      // "9.00 uur" - is not mistaken for a web address.
      const urlRegex =
        /(https?:\/\/|www\.)[^\s]+|\b[a-z0-9][a-z0-9-]*\.(com|net|org|nl|be|de|fr|es|it|info|io|co|uk|eu)\b/i;

      return !urlRegex.test(value);
    },
  });
});
